import { Directive } from '@angular/core';

/**
 * Hilfsdirektive, um zu erkennen, ob sich das Formular bereits in einer Box befindet und daher keine eigene rendern muss.
 * Künftig sollen die Fälle, in denen das Formular selbst die Box rendert, mehr und mehr reduziert werden.
 * Ist das abgeschlossen, und haben Formulare dann per Default keine eigene Box mehr, kann die Direktive ggf wieder ausgeabut werden.
 * (SPP-251)
 */
@Directive({
    selector: '.box'
})
export class BoxDirective {
}
